import { createFlagsScheme, schema, type TypedFeatureFlags } from '@funtech-int/yango-shared';

const flagsSchemeEntries = {
    autoskipDayNight: schema.string.optional('none'),
    autoskipNightTimeToDisable: schema.number.optional(3 * 60 * 60),
    autoskipTimeToDisable: schema.number.optional(5 * 60 * 60),
    autoskipWacthedTime: schema.number.optional(0),
    defaultPlayerError: schema.string.optional(''),
    featurePlayerVersion: schema.string.optional(''),
    filmoscopeVersion: schema.string.optional(''),
    forcedStreamUri: schema.string.optional(''),
    isDynamicPrerollEnabled: schema.boolean.optional(false),
    isNewPlayerEnabled: schema.boolean.optional(false),
    isPlayerDebugMode: schema.boolean.optional(false),
    isPlayerSDKEnabled: schema.boolean.optional(false),
    sessionStopPauseAfter: schema.number.optional(14400),
    withAudioTracksIntersection: schema.boolean.optional(false),
    yaspVersion: schema.string.optional(''),
};

export const featureFlagsScheme = createFlagsScheme(flagsSchemeEntries);

export type PlayerFeatureFlags = TypedFeatureFlags<typeof flagsSchemeEntries>;
